"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = startDictateOnSpeakCompleteSaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _markActivity = require("../../lib/actions/markActivity");

var _activities = require("../selectors/activities");

var _setDictateState = require("../../lib/actions/setDictateState");

var _DictateState = require("../constants/DictateState");

var _dictateState = _interopRequireDefault(require("../selectors/dictateState"));

var _speakingActivity = _interopRequireDefault(require("../definitions/speakingActivity"));

var _startDictate = _interopRequireDefault(require("../actions/startDictate"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(startDictateOnSpeakComplete),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(startDictateOnSpeakCompleteSaga);

function startDictateOnSpeakComplete() {
  var speakingActivities, dictateState;
  return _regenerator["default"].wrap(function startDictateOnSpeakComplete$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)((0, _activities.of)(_speakingActivity["default"]));

        case 2:
          speakingActivities = _context.sent;
          _context.next = 5;
          return (0, _effects.select)(_dictateState["default"]);

        case 5:
          dictateState = _context.sent;

          if (!(dictateState === _DictateState.WILL_START && !speakingActivities.length)) {
            _context.next = 9;
            break;
          }

          _context.next = 9;
          return (0, _effects.put)((0, _startDictate["default"])());

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
} // TODO: [P4] We should turn this into a reducer instead


function startDictateOnSpeakCompleteSaga() {
  return _regenerator["default"].wrap(function startDictateOnSpeakCompleteSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(function (_ref) {
            var type = _ref.type;
            return type === _markActivity.MARK_ACTIVITY || type === _setDictateState.SET_DICTATE_STATE;
          }, startDictateOnSpeakComplete);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}